import { useMutation } from "@apollo/client";
import { UpdateChannelLastSeenDocument } from "../graphql/updateChannelLastSeen.generated";
import { useQueryWithEvent } from "../events";
import { noCacheHeaders } from "@/utils/headers";

const useUpdateChannelLastSeen = () => {
  const [updateChannelLastSeen, { data, loading, error }] = useMutation(
    UpdateChannelLastSeenDocument,
    {
      context: { headers: noCacheHeaders },
    }
  );

  return {
    updateChannelLastSeen: useQueryWithEvent(
      updateChannelLastSeen,
      "channelUpdated"
    ),
    result: data?.updateChannelLastSeen,
    loading,
    error,
  };
};

export default useUpdateChannelLastSeen;
